.support-block-step{display:flex;flex-direction:column;gap:24px;max-width:480px}.support-block-intro,.support-block-note{font-size:14px;color:#707070;margin:0}
/*# sourceMappingURL=support-block-step.component-AG4B3ZFB.css.map */
